import { CHANGE_UNSAVED_CHANGES } from './types';

function unsavedChanges(state) {
    return (dispatch) => {
        return new Promise((res) => {
            dispatch({
                type: CHANGE_UNSAVED_CHANGES,
                payload: state
            });
            // adding  delay to let the updated value to be reflected
            setTimeout(() => {
                res(state);
            },0)
        })
    };
}

export { unsavedChanges };